module.exports = __webpack_public_path__ + "static/media/dodawanie_w_zakresie_10.0321b696.pdf";